export default {
  lead_modal: {
    title: '📩 Check price and availability',
    subtitle:
      'Price and availability may change. Leave your contact — an agent will confirm current conditions.',

    name: 'Your name',
    contact: 'WhatsApp number',
    message: 'Message (optional)',

    cancel: 'Cancel',
    submit: 'Send',
    sending: 'Sending…',

    success: 'Request sent!',
    error_unknown: 'Unknown error'
  }
}
